import {
  ActionType,
  IInquiryDetailPayload,
} from "models/contract/inquiryDetail";
import { IResponse } from "models";

export const sendInquiryDetailAction = (payload: IInquiryDetailPayload) => {
  return {
    type: ActionType.CONTRACT_INFORMATION_INQUIRY_DETAIL,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.CONTRACT_INFORMATION_INQUIRY_DETAIL_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.CONTRACT_INFORMATION_INQUIRY_DETAIL_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.CONTRACT_INFORMATION_INQUIRY_DETAIL_RESET,
  };
};
